import React from 'react'
import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../../images/key_features_logo.png'

class keyfeatures extends React.Component{
  constructor(props){
    super(props);
    this.state={

    }
  }
  render(){
    return (
      <div className="keyfeaturesDiv">
        <text className="featureHeader">Key Features of PropMe</text>
        <div className="row featureRow">
          <div className="col-lg-4 oneTimeBetting">
            <div className="featureSubDiv">
              <text className="oneTimeHeader">One-to-one betting</text>
              <text className="oneTimeContent">Find a prop and send it directly to a user. Challenge your friend.</text>
            </div>
            <div className="featureSubDiv">
              <text className="oneTimeHeader">One-to-many betting</text>
              <text className="oneTimeContent">Create a personalized group of bettors to challenge anytime.</text>
            </div>
            <div className="featureSubDiv">
              <text className="oneTimeHeader">Marketplace</text>
              <text className="oneTimeContent">Send your prop to the marketplace for others to find and challenge.</text>
            </div>
          </div>
          <div className="col-lg-4 featureLogo">
            <img src={Logo} alt="location" className="keylogo"/>
          </div>
          <div className="col-lg-4 textYourBetDiv">
            <div className="featureSubDiv2">
              <text className="oneTimeHeader">TextYourBet</text>
              <text className="oneTimeContent">Find a prop and send it directly to a user. Challenge your friend.</text>
            </div>
            <div className="featureSubDiv2">
              <text className="oneTimeHeader">SideBet</text>
              <text className="oneTimeContent">From our pick 'em contests, send any prop to a friend or your custom betting group.</text>
            </div>
            <div className="featureSubDiv2">
              <text className="oneTimeHeader">Geo-location</text>
              <text className="oneTimeContent">We can serve you props based on your location!!! Our venue-based location services connect you with others at the game!</text>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default keyfeatures
